"use client";

import { useTranslations } from "next-intl";
import { Alert, AlertDescription, AlertTitle } from "@ui/components/alert";
import { AlertCircle } from "lucide-react";

interface AnalyticsErrorStateProps {
  error?: string;
}

export function AnalyticsErrorState({ error }: AnalyticsErrorStateProps) {
  const t = useTranslations();
  
  return (
    <Alert variant="error">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Error</AlertTitle>
      <AlertDescription>
        {error || "An unknown error occurred"}
      </AlertDescription>
    </Alert>
  );
} 